import { render } from "./IconGlobe.vue.js?vue&type=template&id=6ca8ac6a!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconGlobe.vue?vue&type=template&id=6ca8ac6a"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__